<template>
  <div class="declare">
    <div class="footer">
      <div class="footer-img">
        <img class="imgleft" src="images/log11.png" />
        <img class="imgright" src="images/log1.png" />
        <div>
          <span>网络学堂</span>
          <div>Learning platfrom</div>
        </div>
      </div>
      <div class="footer-text">
        <div>版本所有：西南交通大学 继续教育学院</div>
        <div>
          通讯地址：中国四川省成都市二环路北一段111号西南交通大学九里校区5号教学楼
        </div>
        <div>
          联系方式：400-882-1896 &nbsp;&nbsp; 备案号：蜀IPC05026985号-2
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer"
}
</script>

<style scoped>

</style>
